/**
 * @fileoverview Agent definition for the robust-chapter-formatter-v1 primitive.
 *
 * Extracts and reformats a single chapter from a source document.
 * Designed to run on a cheap model at massive scale — one instance per chapter.
 *
 * @category import.story.extraction
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'robust-chapter-formatter-v1',
  kind: 'primitive',
  name: 'Robust Chapter Formatter',
  description: 'Faithfully extracts and reformats a single chapter from a source document. Designed for parallel execution at scale.',
  category: 'import',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2026-03',
    lastUpdated: '2026-03',
    taxonomyPath: 'import.story.extraction',
    usedBy: ['use-robust-chapter-extraction-workflow-v1.ts'],
    relatedAgents: ['chapter-boundary-detector-v1', 'chapter-metadata-extractor-v1'],
  },
};
